//Utils
import { isJavascriptEnabled } from './utils/isJavascriptEnabled';
import { getFocusable } from './utils/getFocusable';
import { nextFocusable } from './utils/nextFocusable';
import { isPrintableChar } from './utils/isPrintableChar';
import { isInputable } from './utils/isInputable';
import { isSet } from './utils/isSet';
import ScrollStopListener from './utils/scrollStopListener';

//IMPORT - CLASSES
import { Layer } from "./classes/Layer";
import { AccordionItem } from "./classes/AccordionItem";
import { ExpandingContent } from "./classes/ExpandingContent";
import { BannerExpanding } from "./classes/BannerExpanding";
import { Dropdown } from "./classes/Dropdown";
import { TabList } from "./classes/TabList";
import { StickyHeader } from "./classes/StickyHeader";
import { Table } from "./classes/Table";
import { Icon } from "./classes/Icon";
import { ToggleBodyClass } from './classes/ToggleBodyClass';
import { navInternal } from './classes/NavInternal';
import { SortTiles } from './classes/SortTiles';
import { VideoSingle } from './classes/VideoSingle';
import { Modal } from './classes/Modal';

import { themeSwitcher } from './functions/themeSwitcher';

isJavascriptEnabled();

themeSwitcher();

const focusableElements = [
    'a[href]:not([disabled]):not([hidden]):not([aria-hidden])',
    'area[href]:not([disabled]):not([hidden]):not([aria-hidden])',
    'input:not([disabled]):not([type="hidden"]):not([aria-hidden])',
    'select:not([disabled]):not([aria-hidden])',
    'textarea:not([disabled]):not([aria-hidden])',
    'button:not([disabled]):not([aria-hidden])',
    'iframe:not([disabled]):not([hidden]):not([aria-hidden])',
    'object:not([disabled]):not([hidden]):not([aria-hidden])',
    'embed:not([disabled]):not([hidden]):not([aria-hidden])',
    '[contenteditable]:not([disabled]):not([hidden]):not([aria-hidden])',
    '[tabindex]'
];
window.focusableElements = focusableElements;

const store = {
    activeLayers: [],
    activeLayer: ''
};
window.store = store;


/** @type {NodeListOf<Element>} */
const tableElms = document.querySelectorAll('.table--js');
tableElms.forEach( function (tableElm) {
    new Table(tableElm);
});


// Finds icon classes on page and replaces background with actual SVG
const iconNodes = document.querySelectorAll(".nyos-icon");
iconNodes.forEach(node => new Icon(node));

function refreshIcons(newIcons){
    // Global function  to run icon scripts against async-loaded instances
    // use: refreshIcons(document.querySelectorAll(".nyos-icon:not(.svg-converted)"))
    newIcons.forEach(node => new Icon(node));
}

window.refreshIcons = refreshIcons;

// Nav Toggles
const menuButton = document.querySelectorAll(".menu-button");
const searchInput = document.querySelector('#search-input');
menuButton.forEach(node => {   
    const layer = node.getAttribute('layer-open');
    const className = `${layer}-open`;
    new ToggleBodyClass(node, className, (isOpen) => {  
        if (isOpen && className === 'site-search-open' && searchInput) {
            searchInput.focus();
        }
    });
});


// Prime Accordion Items
const accordionItems = document.querySelectorAll('.accordion-item');
const accordionAnimationSpeed = window.ACCORDION_SPEED || 300;
accordionItems.forEach(item => new AccordionItem(item, accordionAnimationSpeed));

// Prime Expanding Content Instances
const expandingScopes = document.querySelectorAll('.expanding-content-scope');
const expandingSpeed = window.EXPANDING_SPEED || 900;
expandingScopes.forEach(scope => new ExpandingContent(scope, expandingSpeed));

// Prime Expanding Banner Instances (Simple)
document.querySelectorAll('.banner-expanding').forEach(el => {
  new BannerExpanding(el);
});

// Internal Navigation
const intNav = document.querySelector('.list-nav-internal');
const navStops = document.querySelectorAll('[data-navstop]');
if (intNav && navStops.length > 0) {
    new navInternal(intNav, navStops, () => {
        var navSlider = new Flickity(intNav,{
            contain: true,
            prevNextButtons: false,
            freeScroll: true,
            pageDots: false,
            cellAlign:'left'
        });
        window.addEventListener('native.intNavUpdated', function (e) {
            navSlider.reposition();   
            navSlider.selectCell('.active');
        });
    });
} else if (navStops.length > 0){
    navStops.forEach(item => {
        const title = item.getAttribute('data-navstop');
        const id = title.toLowerCase().replace(/\s+/g, '-').replace(/[^\w\-]+/g, '');
        item.id = id;
    });
}

// Filter Module
const filterNav = document.querySelector('.module-filter-component');
const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
if (filterNav) {
    var filterNavSlider = new Flickity(filterNav,{
        contain: true,
        prevNextButtons: false,
        freeScroll: true,
        pageDots: false,
        draggable: isTouchDevice,
        cellAlign:'left'
    });
}

// Enable Event Sorting Filters
const eventsList = document.querySelector('.list-events-scope');
if(eventsList){
    const list = eventsList.querySelector('.list-tiles');
    const btnSortDate = eventsList.querySelector('.sort-date');
    const btnSortDistance = eventsList.querySelector('.sort-distance');

    if (btnSortDate) {
        btnSortDate.classList.add('active');
        btnSortDate.addEventListener('click', () => {
            new SortTiles(btnSortDate, list).sortByDate();
        });
    }

    if (btnSortDistance) {
        btnSortDistance.addEventListener('click', () => {
            new SortTiles(btnSortDistance, list).sortByDistance();
        });
    }
}

// Enable Sliders (Basic)
document.addEventListener("DOMContentLoaded",function(){
    const basicSliders = document.querySelectorAll('.slider-basic');
    if(basicSliders){
        basicSliders.forEach(node => {   
            var slider = new Flickity(node,{
                wrapAround: true,
                prevNextButtons: false,
                dragThreshold: 10,
                // adaptiveHeight: true
            })
        });
    }
});

// Enable List Sliders
document.addEventListener("DOMContentLoaded",function(){
    const listSliders = document.querySelectorAll('*[class*=list-].is-slider');
    if(listSliders){
        listSliders.forEach(node => {   
            var slider = new Flickity(node,{
                wrapAround: true,
                cellAlign:'left',
                contain: true,
                prevNextButtons: false,
                imagesLoaded: true,
                pageDots: true,
                groupCells: true,
                dragThreshold: 10
            })
        });
    }
});

// Media Single Video Instances
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.media-single').forEach(el => {
    if (el.querySelector('video')) {
      new VideoSingle(el);
    }
  });
});

// MEMBER MODAL

// Decode helper: converts &lt; &gt; &amp; etc. back to characters
const decodeHTML = (input) => {
  if (input == null) return '';
  const t = document.createElement('textarea');
  t.innerHTML = input;
  return t.value;
};

// Option A: Per-button listeners (simple and clear)
function wireModalButtons() {
  const triggers = document.querySelectorAll('button.cta[data-action="trigger-modal"]');
  triggers.forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();

      const img = btn.dataset.img || '';
      const title = btn.dataset.title || '';
      const subtitle = btn.dataset.subtitle || '';
      const body = decodeHTML(btn.dataset.body || '');

      const modal = new Modal({ img, title, subtitle, body });
      modal.open();
    });
  });
}

// Run after DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', wireModalButtons);
} else {
  wireModalButtons();
}